const t = "light", e = "dark", E = "green", n = "grey", r = "dark-grey", s = "custom", c = {
  theme: {
    type: String,
    default: t,
    validator: (o) => [t, e, E, n, r, s].includes(o)
  },
  customTheme: {
    type: String,
    default: null
  }
}, g = {
  light: t,
  dark: e,
  green: E,
  grey: n
};
export {
  g as themeOptions,
  c as themeProp
};
